import {Style, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class MisLayer extends GeoJsonLayer {

    constructor( map, settings = {}){
        settings["name"] = 'mis';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = "MisJSON.php";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "hazards", this.settings['hazards']);
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getColor( feature ){
        return "#CCAA00";
    }

    getHighlightColor( feature ){
        return "#CCCCCC";
    }

    getOpacity(feature){
        return this.options['opacity'];
    }

    getPopupText( feature ){
        let text = this.popupTitle( "MIS", this.property(feature,'hazard'));
        text += this.popupData( "CWSU", this.property(feature,'cwsu')+
            " ["+this.property(feature,'name')+"]" );
        text += this.popupData( "Hazard", this.property(feature,'hazard') + " - " + this.property(feature,'qualifier') );
        text += this.popupData( "Begins", this.property(feature,'valid_time_from') );
        text += this.popupData( "Ends", this.property(feature,'valid_time_to') );
        if( this.property(feature,'top') != undefined )
            text += this.popupData( "Top", this.property(feature,'top') + " ft" );
        if( this.property(feature,'base') != undefined )
            text += this.popupData( "Base",this.property(feature,'base') + " ft" );
        text += this.popupSep();
        let cwa = this.property(feature,'cwa_text');
        cwa = cwa.replace( /\n/g, "<br/>" );
        text += this.popupData( "", cwa );
        text += this.popupEnd();
        return text;
    }

    getSize(feature){
        return 5;
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "image": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), 
                                this.options['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getLineColor(feature), 0.5),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray("#800000")
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }
}
